import ApplicationSerializer from './application';

export default ApplicationSerializer.extend({
  serialize() {
    const json = ApplicationSerializer.prototype.serialize.apply(this, arguments);
    if (json.included) {
      json.included.forEach(({ type, attributes, relationships: { location } }) => {
        if (type == 'employee-locations') {
          // We need to manually set the locationId as a normal attribute
          // so we don't have to load the location model when asking for this id
          attributes['location-id'] = location.data.id;
        }
      });
    }
    return json;
  },
});
